import getCurrentIdWorkoutSelect from '../get-current-id'
import { getStartedIdWorkoutSelect } from '../get-started-id'
import { createSelector } from 'reselect'

const getCurrentOrStartedIdWorkoutSelect = createSelector(
  getCurrentIdWorkoutSelect,
  getStartedIdWorkoutSelect,
  (currentId, startedId) => (
    currentId || startedId
  )
)

export default getCurrentOrStartedIdWorkoutSelect
